import Config from '@config';
import { initializeMeteringDevicePassportTypeApi } from '@gasbi/shared';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

export const meteringDevicePassportTypes =
  initializeMeteringDevicePassportTypeApi({
    baseUrl: Config.VITE_API_CLIENT_URL,
    baseQuery: axiosBaseQuery,
  });

export const {
  meteringDevicePassportTypeApi,
  useGetMeteringDevicePassportTypeQuery,
} = meteringDevicePassportTypes;
